import React, { useState } from 'react';
import { ItemLocation } from '../../../graphql/generatedTypes';
import { Button, Table } from 'reactstrap';
import Checkbox from '../../../components/Checkbox';
import i18n from '@/utils/i18n';
import { FaCheckSquare, FaSquare } from 'react-icons/fa';
import Fuse from 'fuse.js';

type ItemLocationEditTableProps = {
  itemLocations: ItemLocation[];
  allowedLocationIds: string[];
  onChange: (locationId: string) => void;
  toggleAll: () => void;
};

export function ItemLocationEditTable({
  itemLocations,
  allowedLocationIds,
  onChange,
  toggleAll,
}: ItemLocationEditTableProps) {
  const [search, setSearch] = useState('');

  const fuse = new Fuse(itemLocations, {
    keys: ['name'],
  });

  let itemLocationsFiltered = itemLocations;

  if (search.length >= 3) {
    const results = fuse.search(search);
    itemLocationsFiltered = search
      ? results.map((result) => result.item)
      : itemLocations;
  }
  return (
    <div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1">
            {i18n.t('AuthorizedSigner:search')}
          </span>
        </div>
        <input
          type="text"
          className="form-control"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </div>
      <div className="clearfix mt-2 mb-2">
        <Button
          className="float-end"
          style={{ minWidth: '10rem' }}
          onClick={toggleAll}
        >
          {allowedLocationIds.length === 0 ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <FaCheckSquare style={{ alignSelf: 'center' }} />
              {' ' + i18n.t('AuthorizedSigner:selectAll')}
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <FaSquare style={{ alignSelf: 'center' }} />
              {' ' + i18n.t('AuthorizedSigner:deselectAll')}
            </div>
          )}
        </Button>
      </div>
      <Table>
        <thead>
          <tr>
            <th>{i18n.t('AuthorizedSigner:allowed')}</th>
            <th>{i18n.t('AuthorizedSigner:location')}</th>
          </tr>
        </thead>
        <tbody>
          {itemLocationsFiltered.map((location) => (
            <tr key={location.id}>
              <td>
                <Checkbox
                  checked={allowedLocationIds.includes(location.id)}
                  onClick={() => onChange(location.id)}
                ></Checkbox>
              </td>
              <td>{location.name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default ItemLocationEditTable;
